/**
 * @file: This file names a media type for the operator.
 *
 * Four lists draw the icon of a media type. They are the item list of the
 * scene page, the recipe line and the sequence row of Compose, and the bumper
 * list of the takeover panel. All four read this file, so an operator sees one
 * picture for one type everywhere.
 *
 * The report writes the type in a sentence instead of an icon. The word is
 * here beside the icon, so one file names a media type.
 */

const TYPE_ICON = Object.freeze({
  file: 'fa-file',
  social: 'fa-users',
  serviceAnnouncement: 'fa-bullhorn'
})

const UNKNOWN_ICON = 'fa-question'

/**
 * The word for a media type in a sentence. The log holds the type of the app,
 * and `serviceAnnouncement` is not a word the operator reads.
 */
const TYPE_LABEL = Object.freeze({
  file: 'file',
  social: 'social post',
  serviceAnnouncement: 'announcement'
})

/**
 * The Font Awesome class of a media type.
 *
 * @param {string} mediaType - The type of the media
 * @returns {string} The icon class
 */
function iconForMediaType (mediaType) {
  return TYPE_ICON[mediaType] || UNKNOWN_ICON
}

/**
 * The word for a media type. An unknown type keeps its own name.
 *
 * @param {string} mediaType - The type of the media
 * @returns {string} The word for the type
 */
function labelForMediaType (mediaType) {
  return TYPE_LABEL[mediaType] || mediaType
}

export { iconForMediaType, labelForMediaType }
